export class InverseBooleanValueConverter {
    public fromView(value: any): boolean | null {
        return value !== true;
    }

    public toView(value: any): boolean | null {
        return value !== true;
    }
}
